import * as _ from 'lodash';
import * as moment from 'moment';
import 'moment/locale/fr';
import { BehaviorSubject, Subject } from 'rxjs';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { DataSource } from '@app/core/models/data-source.model';
import {
  InvoiceSearchCriteriaModel,
  ValidationType,
} from '@app/core/models/invoices/invoice-search-criteria.model';
import { InvoiceViewType } from '@app/core/models/invoices/invoice-view-type.model';
import { InvoiceModel } from '@app/core/models/invoices/invoice.model';
import { ReferentialsModel } from '@app/core/models/referentials/referentials.model';
import { InvoiceService } from '@app/core/services/invoice.service';
import { MultiSelectModel } from '@app/shared/models/multi-select.model';
import {
  TableRowAction,
  TableActionIcon,
  TableMassAction,
} from '@app/shared/models/table-action-type.model';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { takeUntil, debounceTime } from 'rxjs/operators';
import { TableColumnsConfigKey } from '@app/core/models/configuration/table-columns-config-key.model';
import { ReferentialItem } from '@app/core/models/shared/referential-item.model';
import { DropdownHelper } from '@app/shared/models/dropdown-helper.model';
import { SessionStorageService } from '@app/core/services/session-storage.service';
import { SearchFilterModel } from '@app/core/models/search-filter.model';
import { FileDownloadService } from '@app/core/services/filedownload.service';
import { v4 as uuidv4 } from 'uuid';
import { ProgressComponent } from '@app/shared/components/progress/progress.component';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { ModalHelper } from '@app/shared/models/modal-helper.model';
import { HttpCancelService } from '@app/core/services/http-cancel.service';
import { ConfigService } from '@app/core/config/config.service';
import { TableNavigationModel } from '@app/shared/models/table-navigation.model';
import { ModalComponent } from '@app/shared/components/modal/modal.component';
import { AssetService } from '@app/core/services/asset.service';
import { RecipientEntitiesService } from '@app/core/services/recipient-entities.service';
import { SearchService } from '@app/core/services/search.service';
import { InvoiceDateProcessingType } from '@app/core/models/invoices/invoice-date-processing-type.model';
import { DecimalPipe } from '@angular/common';
import { NumberCommaToDotFormatPipe } from '@app/shared/pipes/number-comma-to-dot-format.pipe';
import { ReferentialItemByCode } from '@app/core/models/shared/referential-item-by-code.model';
import { ExpenseFamilyTypeRef } from '@app/core/models/referentials/expense-family-type.model';
moment.locale('fr');

@Component({
  selector: 'app-invoice-list-search',
  templateUrl: './invoice-list-search.component.html',
  styleUrls: ['./invoice-list-search.component.scss'],
})
export class InvoiceSearchComponent
  extends SearchService<InvoiceSearchCriteriaModel>
  implements OnInit, OnDestroy
{
  invoiceDataSource: DataSource<InvoiceModel>;
  data: InvoiceModel[] = [];
  tableActions: TableRowAction[] = [];
  tableMassActions: TableMassAction[] = [];
  debounceTime = 500;
  filterStorageKey: string;

  private searchInputChanged: Subject<string> = new Subject<string>();

  // multi select
  complaintDropdownList: ReferentialItem[] = [];
  complaintSelectedItems: ReferentialItem[] = [];

  waitingFlagDropdownList: ReferentialItem[] = [];
  waitingFlagSelectedItems: ReferentialItem[] = [];

  workingSituationDropdownList: ReferentialItem[] = [];
  workingSituationSelectedItems: ReferentialItem[] = [];

  rejectionFlagDropdownList: ReferentialItem[] = [];
  rejectionFlagSelectedItems: ReferentialItem[] = [];

  operationalProcessingStatusDropdownList: ReferentialItem[] = [];
  operationalProcessingStatusSelectedItems: ReferentialItem[] = [];

  comptabilityProcessingStatusDropdownList: ReferentialItem[] = [];
  comptabilityProcessingStatusSelectedItems: ReferentialItem[] = [];

  validationStatusDropdownList: ReferentialItem[] = [];
  validationStatusSelectedItems: ReferentialItem[] = [];

  validationTypeDropdownList: ReferentialItem[] = [];
  validationTypeSelected: ReferentialItem[] = [];

  invoiceValidationStatusDropdownList: ReferentialItem[] = [];
  invoiceValidationStatusSelectedItems: ReferentialItem[] = [];

  voucherValidationStatusSelectedItems: ReferentialItem[] = [];
  voucherValidationStatusDropdownList: ReferentialItem[] = [];

  promotionValidationStatusSelectedItems: ReferentialItem[] = [];
  promotionValidationStatusDropdownList: ReferentialItem[] = [];

  expenseFamilyTypeSelectedItems : ExpenseFamilyTypeRef[] = [];
  expenseFamilyTypeDropdownList : ExpenseFamilyTypeRef[] = [];

  expenseTradeTypeSelectedItems : ReferentialItemByCode[] = [];
  expenseTradeTypeDropdownList : ReferentialItemByCode[] = [];

  multipleSelectionWithSearchDropdownSettings: IDropdownSettings = {};
  singleSelectionWithoutSearchDropdownSettings: IDropdownSettings = {};
  multipleSelectionWithoutSearchDropdownSettings: IDropdownSettings = {};

  processingDateTypesDropdownList: ReferentialItem[] = [];
  processingDateTypesSelectedItems: ReferentialItem[] = [];

  displayInvoiceValidationStatusChoices: boolean = true;
  displayVoucherValidationStatusChoices: boolean = true;
  displayPromotionValidationStatusChoices: boolean = true;

  configKey: string = TableColumnsConfigKey.INVOICESEARCH;

  private massDownloadRequestSubject$ = new BehaviorSubject<string>(null);
  public massDownloadRequest$ = this.massDownloadRequestSubject$.asObservable();
  progressDialog: MatDialogRef<ProgressComponent>;

  @Input() onDataSourceChanged: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Input() onExportDataSourceAvailable: EventEmitter<any> =
    new EventEmitter<any>();

  title: string;
  panelOpenState: boolean = true;

  public onExportExcelCaller: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private invoiceService: InvoiceService,
    private fileDownloadService: FileDownloadService,
    private dropdownHelper: DropdownHelper,
    private multiSelectModel: MultiSelectModel,
    protected sessionStorageService: SessionStorageService,
    private httpCancelService: HttpCancelService,
    public assetService: AssetService,
    public recipientEntityService: RecipientEntitiesService,
    private config: ConfigService,
    private decimalPipe: DecimalPipe,
    private numberFormatPipe: NumberCommaToDotFormatPipe
  ) {
    super(sessionStorageService, assetService, recipientEntityService);
    this.searchCriteriaModel = new InvoiceSearchCriteriaModel();
    this.searchCriteriaModel.InvoiceInProgress = true;

    this.title = 'RECHERCHE DES FACTURES';
    this.exportFileName = 'Factures_Recherche';
    this.tableConfig = 'table_config_invoiceSearch';
  }

  onValidationTyChange(
    selectedValue: ReferentialItem,
    displayAll: boolean
  ): void {
    this.displayInvoiceValidationStatusChoices =
      selectedValue.Id != 2 || displayAll;
    this.displayVoucherValidationStatusChoices =
      selectedValue.Id != 1 || displayAll;
    this.displayPromotionValidationStatusChoices =
      selectedValue.Id != 1 || displayAll;
  }

  ngOnInit(): void {
    this.filterStorageKey = this.route.snapshot.data.searchFilterKey;

    this.route.data.subscribe((data) => {
      const referentials: ReferentialsModel = data.referentials;
      this.rejectionFlagDropdownList = referentials.RejectionFlags;
      this.waitingFlagDropdownList = referentials.WaitingFlags;
      this.expenseFamilyTypeDropdownList = referentials.ExpenseFamilyTypes;
      this.expenseTradeTypeDropdownList = referentials.ExpenseTradeTypes;
    });

    this.searchInputChanged
      .pipe(takeUntil(this.unsubscribe$), debounceTime(this.debounceTime))
      .subscribe(() => {
        this.initSearch();
      });

    this.multipleSelectionWithSearchDropdownSettings =
      this.multiSelectModel.getMultipleSelection(true);
    this.multipleSelectionWithSearchDropdownSettings.allowRemoteDataSearch =
      true;
    this.singleSelectionWithoutSearchDropdownSettings =
      this.multiSelectModel.getSingleSelection(true);
    this.multipleSelectionWithoutSearchDropdownSettings =
      this.multiSelectModel.getSingleSelection(false);

    this.processingDateTypesDropdownList = [
      {
        Id: InvoiceDateProcessingType.PROCESSEDAT,
        Label: 'Date de traitement opérationnel',
      },
      {
        Id: InvoiceDateProcessingType.WORKFLOWCOMPLETEDAT,
        Label: 'Date de validation',
      },
      {
        Id: InvoiceDateProcessingType.VOUCHERVALIDATEDAT,
        Label: 'Date de traitement comptable',
      },
    ];
    this.processingDateTypesSelectedItems =
      this.processingDateTypesDropdownList.filter(
        (c) => c.Id === InvoiceDateProcessingType.PROCESSEDAT
      );

    this.complaintDropdownList = this.dropdownHelper.getYesOrNoDropdownList();

    this.workingSituationDropdownList = [
      { Id: 1, Label: 'Situation travaux' },
      { Id: 0, Label: 'Factures' },
    ];
    this.operationalProcessingStatusDropdownList =
      this.dropdownHelper.getYesOrNoAsFlagsDropdownList();
    this.comptabilityProcessingStatusDropdownList =
      this.dropdownHelper.getYesOrNoOrNaDropdownList();
    this.validationStatusDropdownList =
      this.dropdownHelper.getYesOrNoOrNaDropdownList();

    this.tableActions.push(
      new TableRowAction(
        TableActionIcon.ZOOM,
        'Voir le détail de la facture',
        this.onZoom
      )
    );
    this.tableActions.push(
      new TableRowAction(
        TableActionIcon.PDF,
        'Ouvrir la facture',
        this.onOpenPdf
      )
    );
    this.tableActions.push(
      new TableRowAction(
        TableActionIcon.VOUCHER,
        'Télécharger le bon à payer',
        this.onVoucherDownload,
        this.ensureInvoiceIsVoucher
      )
    );

    this.tableMassActions.push(
      new TableMassAction(
        TableActionIcon.VOUCHER,
        'Télécharger les bons à payer',
        this.onMassVouchersDownload,
        this.ensureSelectedItemsAreInWorkflow
      )
    );

    this.setupValidationDropDown();

    this.massDownloadRequest$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((requestId: string) => {
        if (_.isNil(requestId)) {
          if (!_.isNil(this.progressDialog)) {
            this.progressDialog.close(false);
          }
          return;
        }

        const progressModal = new ModalHelper().getProgressConfig(requestId);
        this.progressDialog = this.dialog.open(
          ProgressComponent,
          progressModal
        );

        this.progressDialog
          .afterClosed()
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe((isSuccess: boolean) => {
            this.massDownloadRequestSubject$.next(null);
            this.progressDialog = null;
            if (!isSuccess) {
              this.httpCancelService.cancelPendingRequests();
            }
          });
      });

    this.restoreFilters();
    const pageNavigation = Object.assign(
      {},
      JSON.parse(localStorage.getItem('table_config_invoiceSearch'))?.pageDef
    ) as TableNavigationModel; //Persiste filter
    const defaultPageSize = 20;

    this.sortColumn = pageNavigation.Sort?.active;
    this.sortDirection = pageNavigation.Sort?.direction;
    this.pageIndex = pageNavigation?.Page?.pageIndex ?? 0;
    this.pageSize = pageNavigation.Page?.pageSize ?? defaultPageSize;
    this.initSearch(true);
  }

  clearSearchFilter(): void {
    this.searchCriteriaModel = new InvoiceSearchCriteriaModel();
    this.workingSituationSelectedItems = [];
    this.waitingFlagSelectedItems = [];
    this.rejectionFlagSelectedItems = [];
    this.complaintSelectedItems = [];
    this.assetsSelectedItems = [];
    this.validationTypeSelected = [];
    this.invoiceValidationStatusSelectedItems = [];
    this.voucherValidationStatusSelectedItems = [];
    this.promotionValidationStatusSelectedItems = [];
    this.recipientEntitiesSelectedItems = [];
    this.expenseFamilyTypeSelectedItems = [];
    this.expenseTradeTypeSelectedItems = [];
    this.displayInvoiceValidationStatusChoices = true;
    this.displayVoucherValidationStatusChoices = true;
    this.displayPromotionValidationStatusChoices = true;
    this.pageIndex = 0;
    this.searchInvoices(true);
    this.storeFilters();
  }

  onDeselectProcessingDateTypesItem(item: ReferentialItem): void {
    this.processingDateTypesSelectedItems = [item];
  }

  setupValidationDropDown() {
    this.validationTypeDropdownList = [
      { Id: 2, Label: 'Avec BAP' },
      { Id: 1, Label: 'Sans BAP' },
      { Id: 3, Label: 'Tout' },
    ];
    this.invoiceValidationStatusDropdownList = [
      { Id: 1, Label: 'Non traité' },
      { Id: 2, Label: 'Traité' },
    ];
    this.voucherValidationStatusDropdownList = [
      { Id: 1, Label: 'Non traité' },
      { Id: 2, Label: 'En cours de validation' },
      { Id: 4, Label: 'Validé' },
      { Id: 8, Label: 'Comptabilisé' }
    ];
    this.promotionValidationStatusDropdownList = [
      { Id: 1, Label: 'Non traité' },
      { Id: 2, Label: 'En attente de validation N1 Promotion' },
      { Id: 4, Label: 'En attente de validation N2 Promotion' },
      { Id: 8, Label: 'En attente de BAP Promotion' },
      { Id: 16, Label: 'Comptabilisé Promotion' },
      { Id: 32, Label: 'Partiellement réglée' },
      { Id: 64, Label: 'Réglée' },
      { Id: 128, Label: 'Annulée PPR' }
    ];
  }

  getInvoiceForExport = () => {
    this.invoiceService
      .searchInvoices(
        this.sortColumn,
        this.sortDirection,
        0,
        this.config.environnement.maxExportRows,
        this.searchCriteriaModel
      )
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((invoiceDataSource: DataSource<InvoiceModel>) => {
        this.onExportDataSourceAvailable.emit(invoiceDataSource.Items);
      });
  };

  searchInvoices(dataContentChanged: boolean) {
    this.invoiceService
      .searchInvoices(
        this.sortColumn,
        this.sortDirection,
        this.pageIndex,
        this.pageSize,
        this.searchCriteriaModel
      )
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (invoiceDataSource: DataSource<InvoiceModel>) => {
          this.data = invoiceDataSource.Items;
          this.paginatorLength = invoiceDataSource.TotalItems;
          this.onDataSourceChanged.emit(dataContentChanged);
          this.storeFilters();
        },
        (_) => {
          this.sortColumn = null;
          this.sortDirection = null;
          this.searchInvoices(dataContentChanged);
        }
      );
  }

  inputChangedAmount(result: any) {
    this.onInputChanged(result.type, result.selectedValue);
  }

  onInputChanged(type: string, selectedValue: any): void {
    const newValue = this.decimalPipe.transform(
      selectedValue.replace(',', '.'),
      '1.2-2'
    );
    const newAmount = !_.isNil(newValue)
      ? this.numberFormatPipe.transformfromString(newValue)
      : null;

    switch (type) {
      case 'From':
        this.searchCriteriaModel.FromAmount = newAmount;
        break;
      case 'To':
        this.searchCriteriaModel.ToAmount = newAmount;
        break;
    }

    this.searchInputChanged.next('');
  }

  inputChanged() {
    this.searchInputChanged.next('');
  }

  dateChangeSearch(result: any) {
    this.dateChange(result.type, result.selectedDate);
  }

  dateChange(type: string, selectedDate: any): void {
    var formated = !_.isNil(selectedDate)
      ? moment(selectedDate).format('YYYY-MM-DD')
      : null;

    switch (type) {
      case 'FromReceptionDate':
        this.searchCriteriaModel.FromReceptionDate = formated;
        break;
      case 'ToReceptionDate':
        this.searchCriteriaModel.ToReceptionDate = formated;
        break;
      case 'FromProcessingDate':
        this.searchCriteriaModel.FromProcessingDate = formated;
        break;
      case 'ToProcessingDate':
        this.searchCriteriaModel.ToProcessingDate = formated;
        break;
      case 'FromInvoiceDate':
        this.searchCriteriaModel.FromInvoiceDate = formated;
        break;
      case 'ToInvoiceDate':
        this.searchCriteriaModel.ToInvoiceDate = formated;
        break;
    }
    this.inputChanged();
  }

  onSortChange = (sort: Sort) => {
    if (
      sort &&
      sort.active != 'Id' &&
      sort.active != 'Box' &&
      sort.active != 'Indication'
    ) {
      this.sortColumn = sort.active.includes('.')
        ? _.last(sort.active.split('.'))
        : sort.active;
      this.sortDirection = sort.direction;
      this.pageIndex = 0;
      this.searchInvoices(true);
    }
  };

  onPageChange = (page: PageEvent) => {
    this.pageIndex = page.pageIndex;
    this.pageSize = page.pageSize;
    this.searchInvoices(false);
  };

  onItemSelect(filter?: string) {
    switch (filter) {
      case 'assets':
        this.areAllAssetsSelected = false;
        break;
      case 'recipientEntity':
        this.areAllRecipientEntitiesSelected = false;
        break;
    }
    this.initSearch();
  }

  initSearch(skipResetPageIndex: boolean = false) {
    this.searchCriteriaModel.IsWorkingSituation =
      this.workingSituationSelectedItems &&
      this.workingSituationSelectedItems.length == 1
        ? _.head(this.workingSituationSelectedItems).Id === 1
        : null;

    this.searchCriteriaModel.RejectionFlag =
      this.rejectionFlagSelectedItems &&
      this.rejectionFlagSelectedItems.length >= 1
        ? this.rejectionFlagSelectedItems
            .map((x) => x['Id'])
            .reduce((x, y) => x + y)
        : null;

    this.searchCriteriaModel.IsComplaint =
      this.complaintSelectedItems
      && this.complaintSelectedItems.length == 1
        ? (this.complaintSelectedItems[0].Label == 'Oui') ? true : false : null;

    this.searchCriteriaModel.WaitingFlag =
      this.waitingFlagSelectedItems && this.waitingFlagSelectedItems.length >= 1
        ? this.waitingFlagSelectedItems
            .map((x) => x['Id'])
            .reduce((x, y) => x + y)
        : null;

    this.searchCriteriaModel.ExpenseFamilyCode =
      this.expenseFamilyTypeSelectedItems
      && this.expenseFamilyTypeSelectedItems.length >= 1
        ? this.expenseFamilyTypeSelectedItems
            .map((x) => x['FamilyCode'])
            .reduce((x, y) => x + y)
        : null;

    this.searchCriteriaModel.ExpenseTradeCode =
      this.expenseTradeTypeSelectedItems
      && this.expenseTradeTypeSelectedItems.length >= 1
        ? this.expenseTradeTypeSelectedItems
            .map((x) => x['Code'])
            .reduce((x, y) => x + y)
        : null;

    this.searchCriteriaModel.ValidationType =
      this.validationTypeSelected && this.validationTypeSelected.length >= 1
        ? (this.validationTypeSelected[0].Id as ValidationType)
        : null;

    this.searchCriteriaModel.InvoiceValidationStatusIds =
      this.searchCriteriaModel.ValidationType != ValidationType.Voucher &&
      this.invoiceValidationStatusSelectedItems &&
      this.invoiceValidationStatusSelectedItems.length >= 1
        ? this.invoiceValidationStatusSelectedItems
          .map((x) => x['Id'])
          .reduce((x, y) => x + y)
        : null;

    this.searchCriteriaModel.VoucherValidationStatusIds =
      this.searchCriteriaModel.ValidationType != ValidationType.Invoice &&
      this.voucherValidationStatusSelectedItems &&
      this.voucherValidationStatusSelectedItems.length >= 1
        ? this.voucherValidationStatusSelectedItems
          .map((x) => x['Id'])
          .reduce((x, y) => x + y)
        : null;

    this.searchCriteriaModel.PromotionValidationStatusIds =
      this.searchCriteriaModel.ValidationType != ValidationType.Invoice &&
      this.promotionValidationStatusSelectedItems &&
      this.promotionValidationStatusSelectedItems.length >= 1
        ? this.promotionValidationStatusSelectedItems
          .map((x) => x['Id'])
          .reduce((x, y) => x + y)
        : null;

    this.searchCriteriaModel.PrimaryReference =
      this.assetsSelectedItems &&
      this.assetsSelectedItems.length >= 1 &&
      !this.areAllAssetsSelected
        ? this.assetsSelectedItems.map((a) => a.Label)
        : null;

    this.searchCriteriaModel.RecipientEntity =
      this.recipientEntitiesSelectedItems &&
      this.recipientEntitiesSelectedItems.length >= 1 &&
      !this.areAllRecipientEntitiesSelected
        ? this.recipientEntitiesSelectedItems.map((r) => r.Id.toString())
        : null;

    if (_.isNil(this.searchCriteriaModel.FromAmount)) {
      this.searchCriteriaModel.FromAmount = null;
    }

    if (_.isNil(this.searchCriteriaModel.ToAmount)) {
      this.searchCriteriaModel.ToAmount = null;
    }

    this.searchCriteriaModel.ProcessingDateType =
      this.processingDateTypesSelectedItems &&
      this.processingDateTypesSelectedItems.length == 1
        ? _.head(this.processingDateTypesSelectedItems).Id
        : null;

    if (!skipResetPageIndex) {
      this.pageIndex = 0;
    }

    this.searchInvoices(!skipResetPageIndex);
  }

  onSelectAll(items: any, filter: string) {
    switch (filter) {
      case 'rejectionFlag':
        this.rejectionFlagSelectedItems = items;
        break;
      case 'complaint':
        this.complaintSelectedItems = items;
        break;
      case 'waitingFlag':
        this.waitingFlagSelectedItems = items;
        break;
      case 'workingSituation':
        this.workingSituationSelectedItems = items;
        break;
      case 'operationalProcessingStatus':
        this.operationalProcessingStatusSelectedItems = items;
        break;
      case 'comptabilityProcessingStatus':
        this.comptabilityProcessingStatusSelectedItems = items;
        break;
      case 'validationStatus':
        this.validationStatusSelectedItems = items;
        break;
      case 'voucherValidationStatus':
        this.voucherValidationStatusSelectedItems = items;
        break;
      case 'promotionValidationStatus':
        this.promotionValidationStatusSelectedItems = items;
        break;
      case 'invoiceValidationStatus':
        this.invoiceValidationStatusSelectedItems = items;
        break;
      case 'promotionValidationStatus':
        this.promotionValidationStatusDropdownList = items;
        break;
      case 'assets':
        this.assetsSelectedItems = this.areAllAssetsSelected ? [] : items;
        this.areAllAssetsSelected = true;
        break;
      case 'recipientEntity':
        this.recipientEntitiesSelectedItems = this
          .areAllRecipientEntitiesSelected
          ? []
          : items;
        this.areAllRecipientEntitiesSelected = true;
        break;
      case 'expenseFamilyType':
          this.expenseFamilyTypeSelectedItems = items;
          break;
      case 'expenseTradeType' :
          this.expenseTradeTypeSelectedItems = items;
          break;
    }
    this.initSearch();
  }

  protected restoreFiltersInner(
    searchFilter: SearchFilterModel<InvoiceSearchCriteriaModel>
  ): void {
    const yesChoice = { Id: 1, Label: 'Oui' } as ReferentialItem;
    const noChoice = { Id: 2, Label: 'Non' } as ReferentialItem;

    if (
      !_.isNil(searchFilter.Filter.IsWorkingSituation) &&
      searchFilter.Filter.IsWorkingSituation !== ''
    ) {
      this.workingSituationSelectedItems =
        this.workingSituationDropdownList.filter(
          (w) => w.Id === (searchFilter.Filter.IsWorkingSituation ? 1 : 0)
        );
    }

    if (!_.isNil(searchFilter.Filter.Number)) {
      this.searchCriteriaModel.Number = searchFilter.Filter.Number;
    }

    if (
      !_.isNil(searchFilter.Filter.WaitingFlag) &&
      searchFilter.Filter.WaitingFlag !== ''
    ) {
      this.waitingFlagSelectedItems = this.waitingFlagDropdownList.filter(
        (r) => ((searchFilter.Filter.WaitingFlag as number) & r.Id) == r.Id
      );
    }

    if (!_.isNil(searchFilter.Filter.IsComplaint) &&
    searchFilter.Filter.IsComplaint !== ''
    ) {
      this.complaintSelectedItems = searchFilter.Filter.IsComplaint ? [yesChoice] : [noChoice];
    }

    if (
      !_.isNil(searchFilter.Filter.RejectionFlag) &&
      searchFilter.Filter.RejectionFlag != ''
    ) {
      this.rejectionFlagSelectedItems = this.rejectionFlagDropdownList.filter(
        (r) => ((searchFilter.Filter.RejectionFlag as number) & r.Id) == r.Id
      );
    }

    if (!_.isNil(searchFilter.Filter.ValidationType)) {
      this.validationTypeSelected = this.validationTypeDropdownList.filter(
        (a) => a.Id == searchFilter.Filter.ValidationType
      );
      this.onValidationTyChange(_.head(this.validationTypeSelected), false);
    }

    if (!_.isNil(searchFilter.Filter.InvoiceValidationStatusIds)) {
      this.invoiceValidationStatusSelectedItems =
        this.invoiceValidationStatusDropdownList.filter(
          (a) => a.Id == searchFilter.Filter.InvoiceValidationStatusIds
        );
    }

    if (!_.isNil(searchFilter.Filter.VoucherValidationStatusIds)) {
      this.voucherValidationStatusSelectedItems =
        this.voucherValidationStatusDropdownList.filter(
          (a) => a.Id == searchFilter.Filter.VoucherValidationStatusIds
        );
    }

    if (!_.isNil(searchFilter.Filter.PromotionValidationStatusIds)) {
      this.promotionValidationStatusSelectedItems =
        this.promotionValidationStatusDropdownList.filter(
          (a) => a.Id == searchFilter.Filter.PromotionValidationStatusIds
        );
    }

    if (!_.isNil(searchFilter.Filter.FromAmount)) {
      this.searchCriteriaModel.FromAmount = searchFilter.Filter.FromAmount;
    }

    if (!_.isNil(searchFilter.Filter.ToAmount)) {
      this.searchCriteriaModel.ToAmount = searchFilter.Filter.ToAmount;
    }

    if (!_.isNil(searchFilter.Filter.FromInvoiceDate)) {
      this.searchCriteriaModel.FromInvoiceDate =
        searchFilter.Filter.FromInvoiceDate;
    }

    if (!_.isNil(searchFilter.Filter.ToInvoiceDate)) {
      this.searchCriteriaModel.ToInvoiceDate =
        searchFilter.Filter.ToInvoiceDate;
    }

    if (!_.isNil(searchFilter.Filter.FromProcessingDate)) {
      this.searchCriteriaModel.FromProcessingDate =
        searchFilter.Filter.FromProcessingDate;
    }

    if (!_.isNil(searchFilter.Filter.ToProcessingDate)) {
      this.searchCriteriaModel.ToProcessingDate =
        searchFilter.Filter.ToProcessingDate;
    }

    if (!_.isNil(searchFilter.Filter.FromReceptionDate)) {
      this.searchCriteriaModel.FromReceptionDate =
        searchFilter.Filter.FromReceptionDate;
    }

    if (!_.isNil(searchFilter.Filter.ToReceptionDate)) {
      this.searchCriteriaModel.ToReceptionDate =
        searchFilter.Filter.ToReceptionDate;
    }

    if (!_.isNil(searchFilter.Filter.ProcessingDateType)) {
      this.processingDateTypesSelectedItems = [
        ...this.processingDateTypesDropdownList.filter(
          (r) => searchFilter.Filter.ProcessingDateType === r.Id
        ),
      ];
    }

    if (
      !_.isNil(searchFilter.Filter.RecipientEntity) &&
      _.isArray(searchFilter.Filter.RecipientEntity) &&
      searchFilter.Filter.RecipientEntity.length > 0
    ) {
      this.searchCriteriaModel.RecipientEntity =
        searchFilter.Filter.RecipientEntity;
    }

    if (
      !_.isNil(searchFilter.Filter.PrimaryReference) &&
      _.isArray(searchFilter.Filter.PrimaryReference) &&
      searchFilter.Filter.PrimaryReference.length > 0
    ) {
      this.searchCriteriaModel.PrimaryReference =
        searchFilter.Filter.RecipientEntity;
    }

    if (
      !_.isNil(searchFilter.Filter.ExpenseFamilyCode) &&
      searchFilter.Filter.ExpenseFamilyCode !== ''
    ) {
      this.expenseFamilyTypeSelectedItems = this.expenseFamilyTypeDropdownList.filter(
        (r) => (searchFilter.Filter.ExpenseFamilyCode as string) == r.FamilyCode
      );
    }

    if (
      !_.isNil(searchFilter.Filter.ExpenseTradeCode) &&
      searchFilter.Filter.ExpenseTradeCode !== ''
    ) {
      this.expenseTradeTypeSelectedItems = this.expenseTradeTypeDropdownList.filter(
        (r) => (searchFilter.Filter.ExpenseTradeCode as string) == r.Code
      );
    }
    
    this.searchCriteriaModel.InvoiceInProgress = true;
  }

  onZoom = (data: InvoiceModel) => {
    this.router.navigate([
      'invoices',
      InvoiceViewType.SEARCH,
      'detail',
      data.Id,
    ]);
  };

  onOpenPdf = (data: InvoiceModel) => {
    window.open(
      `invoices/${InvoiceViewType.SEARCH}/detail-pdf/${data.Id}`,
      '_blank'
    );
  };

  onVoucherDownload = (invoice: InvoiceModel) => {
    if (invoice.IsPPR) {
      this.invoiceService
        .getAttachmentPromotion(invoice.Id)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((blobData: Blob) => {
          let date = moment(invoice.IssuedAt).format('YYYYMMDo');
          this.fileDownloadService.downloadBlob(
            blobData,
            `${invoice.Number}_${date}_${invoice.AmountTaxIncluded.toFixed(
              0
            )}_${invoice.SupplierCompanyName}.pdf`,
            'application/pdf'
          );
        });
    } else {
      this.invoiceService
        .getAttachmentVoucher(invoice.Id)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((blobData: Blob) => {
          let date = moment(invoice.IssuedAt).format('YYYYMMDo');
          this.fileDownloadService.downloadBlob(
            blobData,
            `${invoice.Number}_${date}_${invoice.AmountTaxIncluded.toFixed(
              0
            )}_${invoice.SupplierCompanyName}.pdf`,
            'application/pdf'
          );
        });
    }
  };

  ensureSelectedItemsAreInWorkflow = (data: string[]): boolean => {
    let selectedInvoices = this.data.filter((invoice: InvoiceModel) =>
      data.includes(invoice.Id)
    );
    return !selectedInvoices.some(
      (invoice: InvoiceModel) =>
        !invoice.IsVoucher || !invoice.IsProcessed || _.isNil(invoice.Workflow)
    );
  };

  onServerSideAllDownload = () => {
    this.invoiceService
      .searchInvoices(
        this.sortColumn,
        this.sortDirection,
        0,
        this.config.environnement.maxExportRows,
        this.searchCriteriaModel
      )
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((invoiceDataSource: DataSource<InvoiceModel>) => {
        let massDownloadRequest = uuidv4();
        this.massDownloadRequestSubject$.next(massDownloadRequest);
        const invoiceIds = invoiceDataSource.Items.map((invoice) => invoice.Id);
        this.invoiceService
          .getInvoicesAttachment(invoiceIds, massDownloadRequest)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(
            (blobData: Blob) => {
              this.massDownloadRequestSubject$.next(null);
              let localDate = new Date().toLocaleDateString();
              this.fileDownloadService.downloadBlob(
                blobData,
                `${this.configKey}_${localDate}.zip`,
                'application/zip'
              );
            },
            (_) => {
              this.massDownloadRequestSubject$.next(null);
              const modalErreurConfig = new ModalHelper().getAlertConfig(
                `Une erreur est survenue lors du téléchargement.`
              );
              this.dialog.open(ModalComponent, modalErreurConfig);
            }
          );
      });
  };

  onMassVouchersDownload = (selectedIds: string[]) => {
    if (selectedIds.length > 0) {
      let massDownloadRequest = uuidv4();
      this.massDownloadRequestSubject$.next(massDownloadRequest);
      this.invoiceService
        .getAttachmentVouchers(selectedIds, massDownloadRequest)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (blobData: Blob) => {
            this.massDownloadRequestSubject$.next(null);
            let localDate = new Date().toLocaleDateString();
            this.fileDownloadService.downloadBlob(
              blobData,
              `${this.configKey}_${localDate}.zip`,
              'application/zip'
            );
          },
          (_) => {
            this.massDownloadRequestSubject$.next(null);
            const modalErreurConfig = new ModalHelper().getAlertConfig(
              `Une erreur est survenue lors du téléchargement.`
            );
            this.dialog.open(ModalComponent, modalErreurConfig);
          }
        );
    }
  };

  ensureInvoiceIsVoucher = (data: InvoiceModel): boolean => {
    return (data.IsVoucher && data.IsProcessed) || data.IsPPR;
  };

  ngOnDestroy() {
    this.unsubscribe$.next(true);
  }

  exportAsExcel(): void {
    this.onExportExcelCaller.next();
  }

  onShowFilter(panelvalue: boolean) {
    this.panelOpenState = panelvalue;
  }
}
